import { useState } from 'react';
import { IconButton } from '@mui/material';
import { Delete, Key } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { useDelete, useNotify } from 'react-admin';
import { CHANGE_PASS_ROUTE, USERS } from '@/utils/CONST';
import DeleteDialog from '@/components/common/delete-dialog/delete-dialog';
import useGetCurrentUser from '@/hooks/useGetCurrentUser';
import extractIdFromURI from '@/utils/id';
import { useNavigate } from 'react-router';
import EditIcon from '@mui/icons-material/Edit';

interface Props {
    userId: string;
}
const ActionField = ({ userId }: Props) => {
    const [deleteOne, { isLoading }] = useDelete();
    const notify = useNotify();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const { currentUserId, isLoading: isLoadingUser } = useGetCurrentUser();
    const navigate = useNavigate();

    const goToEditUser = () => {
        navigate(`/users/edit/${extractIdFromURI(userId)}`);
    };

    const handleDeleteOne = () => {
        deleteOne(
            USERS,
            {
                id: userId,
                meta: {
                    requestType: 'update',
                    id: `${userId}/hide`,
                    data: {
                        hide: true,
                    },
                },
            },
            {
                onSuccess: () => {
                    notify('ra.notification.deleted', {
                        type: 'success',
                        messageArgs: { smart_count: 1 },
                    });
                    setOpenDeleteModal(false);
                },
                mutationMode: 'optimistic',
            },
        );
    };

    return (
        <Box display={'flex'} justifyContent={'end'} width={'100%'}>
            <IconButton
                // disabled={isLoading || isLoadingUser || currentUser?.id === extractIdFromURI(userId)}
                onClick={() => navigate(`${CHANGE_PASS_ROUTE}/${extractIdFromURI(userId)}`)}
                color={'primary'}
            >
                <Key />
            </IconButton>

            <IconButton
                disabled={isLoading || isLoadingUser || currentUserId === extractIdFromURI(userId)}
                onClick={goToEditUser}
                color={'primary'}
            >
                <EditIcon />
            </IconButton>

            <IconButton
                disabled={isLoading || isLoadingUser || currentUserId === extractIdFromURI(userId)}
                onClick={() => setOpenDeleteModal(true)}
                color={'primary'}
            >
                <Delete />
            </IconButton>

            {openDeleteModal && (
                <DeleteDialog
                    isLoading={isLoading}
                    onClose={() => setOpenDeleteModal(false)}
                    onClick={handleDeleteOne}
                />
            )}
        </Box>
    );
};

export default ActionField;
